export enum LogLevel {
  UNKNOWN = 0,
  TRACE = 1,
  DEBUG = 2,
  INFO = 3,
  ERROR = 4,
  FATAL = 5,
  CRITICAL_ERROR = 6,
}
